export const ACTIONS = {
	SET_EXTENSION_DATA: 'SET_EXTENSION_DATA',
	SET_LONG_ID: 'SET_LONG_ID',
	SET_LIST_URL: 'SET_LIST_URL',
	SET_ENV: 'SET_ENV',
	SET_SDK: 'SET_SDK',
	SET_SDK_VERSION: 'SET_SDK_VERSION',
	SET_SDK_INTEGRITY: 'SET_SDK_INTEGRITY',
	SET_SDK_STATE: 'SET_SDK_STATE',
	PAY: 'PAY',
	SET_ACTIVE_PAYMENT_METHOD: 'SET_ACTIVE_PAYMENT_METHOD',
	SET_FORCE_HOSTED_FLOW: 'SET_FORCE_HOSTED_FLOW',
	SET_ORDER_ID: 'SET_ORDER_ID',
	SET_LONG_ID_TO_CHARGE: 'SET_LONG_ID_TO_CHARGE',
	SET_ON_PAYMENT_UNSUCCESSFUL_NONCE: 'SET_ON_PAYMENT_UNSUCCESSFUL_NONCE',

	// Component handling actions.

	ADD_COMPONENT: 'ADD_COMPONENT',
	REMOVE_COMPONENT: 'REMOVE_COMPONENT',
	SET_IS_VALID: 'SET_IS_VALID',
	SET_IS_MOUNTED: 'SET_IS_MOUNTED',
	SET_IS_READY: 'SET_IS_READY',
	MOUNT_COMPONENTS: 'MOUNT_COMPONENTS',
};
